import { render, staticRenderFns } from "./PromotionModal.vue?vue&type=template&id=57fd4d5d"
import script from "./PromotionModal.vue?vue&type=script&lang=js"
export * from "./PromotionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports